// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/print","css/app"], () => (__webpack_require__("./src/js/app.js")))
__webpack_require__.O(undefined, ["css/print","css/app"], () => (__webpack_require__("./src/scss/app.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/print","css/app"], () => (__webpack_require__("./src/scss/print.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
